import React from 'react';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import Button from '../../UI/Button/Button';

import authCompletedImage from './img/completed-background.svg';

const authCompleted = () => {

    return (
        <React.Fragment>
            <div className={`mb-6 u-phoneTextAlignCenter`}>
                <HeadingBox>
                    <div className="mb-1">
                        <HeadingH2 size={26} weight="Regular" color="Dark">You are All Set!</HeadingH2>
                    </div>
                    <HeadingH3 size={13} weight="Regular" color="Light">Congratulations! Your account has been Successfully created</HeadingH3>
                </HeadingBox>
            </div>
            <div className={`u-flex justify-content-center align-items-center`}>
                <img src={authCompletedImage}  alt="Authentication Completed" style={{width: '100%', maxWidth: '100%'}}/>
            </div>
            <div className={`mt-10`}>
                <Button theme='OutlinePrimary' width='Block' type='Continue'>Let's travel</Button>
            </div>
        </React.Fragment>
    );
}

export default authCompleted;


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthCompleted/AuthCompleted.js